// extracted by mini-css-extract-plugin
var _1 = "dark-mode";
var _2 = "PYndl6uIsfiWWK0r6iNk";
export { _1 as "dark-mode", _2 as "wrapper" }
